  import React, { Suspense,lazy } from 'react';
  const Cloudhosting = lazy(() => import("./component/cloudhosting"));
  const Banner = lazy(() => import("./component/banner"));
  const Designanddevelopment = lazy(() => import("./component/designanddevelopment"));
  const Features = lazy(() => import("./component/ourfeature"));
  const Ourawesometeam = lazy(() => import("./component/ourawesometeam"));

  function Home (){
    return(
        <>
            <div className="home">
            <Suspense fallback={<div>Loading....</div>}>
               <Banner />
               </Suspense>
               <Suspense fallback={<div>Loading....</div>}>
                 <Cloudhosting />
               </Suspense>
               <Suspense fallback={<div>Loading....</div>}>
                 <Designanddevelopment />
               </Suspense>
               <Suspense fallback={<div>Loading....</div>}>
                 <Features />
               </Suspense>
               <Suspense fallback={<div>Loading....</div>}>
                 <Ourawesometeam />
               </Suspense>
            </div>
        </>
    )
    
  }

  export default Home;